<template>
  <div id="table1">
    <div class="title">
      <i class="iconfont icon-exe-sale-primary"
         style="color: aqua; font-size: 15px; margin-right: 5px"></i>
      <span style="font-size: 18px; font-weight: 'bold'">{{ title }}</span><dv-decoration-1 style="width: 100px; height: 20px" />
    </div>
    <div v-if="config.data.length === 0"
         class="no-data">暂无数据</div>
    <dv-scroll-board v-else
                     :config="config"
                     ref="scrollBoard"
                     @mouseover.native="handleMouseOver"
                     @mouseleave.native="handleMouseLeave"
                     @click="handleToList(config)"
                     style="width: 100%; height: 95%; font-size: 12px" />
    <el-tooltip v-model="tooltipVisible"
                :content="tooltipContent"
                placement="top"
                :popper-options="{positionFixed: true}"
                effect="light"
                :manual="true">
      <div ref="tooltipAnchor"
           style="position: absolute; pointer-events: none; opacity: 0;"></div>
    </el-tooltip>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    tableData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      config: {
        header: [
          '罐号',
          '物料名称',
          // '期初库存',
          '入库数量',
          '出库数量',
          // '调和数量',
          // '调整数量',
          '库存量'
        ],
        data: [
          // ['丰利库区', '92#汽油', '一级', 6, '2021-01-01 00:00', 8],
          // ['丰利库区', '92#汽油', '一级', 6, '2021-01-01 00:00', 8],
          // ['丰利库区', '92#汽油', '一级', 6, '2021-01-01 00:00', 8],
          // ['丰利库区', '92#汽油', '一级', 6, '2021-01-01 00:00', 8],
          // ['丰利库区', '92#汽油', '一级', 6, '2021-01-01 00:00', 8],
          // ['丰利库区', '92#汽油', '一级', 6, '2021-01-01 00:00', 8],
          // ['丰利库区', '92#汽油', '一级', 6, '2021-01-01 00:00', 8],
          // ['丰利库区', '92#汽油', '一级', 6, '2021-01-01 00:00', 8],
          // ['丰利库区', '92#汽油', '一级', 6, '2021-01-01 00:00', 8],
          // ['丰利库区', '92#汽油', '一级', 6, '2021-01-01 00:00', 8],
          // ['丰利库区', '92#汽油', '一级', 6, '2021-01-01 00:00', 8],
          // ['丰利库区', '92#汽油', '一级', 6, '2021-01-01 00:00', 8],
          // ['丰利库区', '92#汽油', '一级', 6, '2021-01-01 00:00', 8],
          // ['丰利库区', '92#汽油', '一级', 6, '2021-01-01 00:00', 8],
          // ['丰利库区', '92#汽油', '一级', 6, '2021-01-01 00:00', 8],
          // ['丰利库区', '92#汽油', '一级', 6, '2021-01-01 00:00', 8],
          // ['丰利库区', '92#汽油', '一级', 6, '2021-01-01 00:00', 8],
          // ['丰利库区', '92#汽油', '一级', 6, '2021-01-01 00:00', 8],
          // ['丰利库区', '92#汽油', '一级', 6, '2021-01-01 00:00', 8],
          // ['丰利库区', '92#汽油', '一级', 6, '2021-01-01 00:00', 8],
          // ['丰利库区', '92#汽油', '一级', 6, '2021-01-01 00:00', 8],
          // ['丰利库区', '92#汽油', '一级', 6, '2021-01-01 00:00', 8]
        ],
        hoverPause: true, // 鼠标悬浮时暂停轮播
        rowNum: 6, // 表格行数
        headerHeight: 35, // 表头高度
        headerBGC: '#0f1325', // 表头背景颜色
        oddRowBGC: '#0f1325', // 奇数行背景颜色
        evenRowBGC: '#171c33', // 偶数行背景颜色
        // index: true, // 是否开启序号
        // indexHeader: '序号', // 序号名称
        // columnWidth: ['100', '200', '100', '100', '100'], // 表头宽度Array[x,x,x,x]
        waitTime: 6000, // 翻页时间
        carousel: 'page', // 滚动类型page为整页，默认为单条
        align: [
          'center',
          'center',
          'center',
          'center',
          'center'
        ] // 对齐方式Array[x,x,x,x]
      },
      tooltipVisible: false,
      tooltipContent: '',
      currentCell: null
    }
  },
  created () {
  },
  mounted () {
    const tempArr = this.tableData.map(item => {
      // const { oilTankCode, itemName, openingQuantity, storageQuantity, outQuantity, blendQuantity, adjustQuantity, nowQuantity } = item
      // return [oilTankCode, itemName, openingQuantity, storageQuantity, outQuantity, blendQuantity, adjustQuantity, nowQuantity]
      const { oilTankCode, itemName, storageQuantity, outQuantity, nowQuantity } = item
      return [oilTankCode, itemName, storageQuantity, outQuantity, nowQuantity]
    })
    this.config = tempArr.length ? { ...this.config, data: tempArr } : { data: [] }
    window.addEventListener('resize', () => {
      this.$refs['scrollBoard'].updateRows()
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', () => {
      this.$refs['scrollBoard'].updateRows()
    })
  },
  methods: {
    handleMouseOver (event) {
      this.tooltipVisible = false
      // 找到鼠标所在的单元格
      const cell = event.target.closest('.dv-scroll-board .row-item .ceil')
      if (!cell) {
        return
      }
      // 获取罐号
      const tankNum = cell.parentNode && cell.parentNode.children[0].innerText
      if (tankNum) {
        // 数据行
        const rowData = this.tableData.find(item => item.oilTankCode === tankNum)
        const { createTimeMin, createTimeMax, oilTankCode, itemName, storageQuantity, outQuantity, nowQuantity } = rowData
        this.tooltipContent = `${moment(createTimeMin).format('YYYY-MM-DD')}至${moment(createTimeMax).format('YYYY-MM-DD')}期间，${oilTankCode}罐（${itemName}），入库：${storageQuantity}吨，出库：${outQuantity}吨，库存：${nowQuantity}吨`
        this.currentCell = cell
        // 更新 tooltip 位置
        this.$nextTick(() => {
          const rect = cell.getBoundingClientRect()
          this.$refs.tooltipAnchor.style.left = `${rect.left + rect.width / 2 + window.pageXOffset - 240}px`
          this.$refs.tooltipAnchor.style.top = `${rect.top + window.pageYOffset - 220}px`
          this.tooltipVisible = true
        })
      }
    },
    handleMouseLeave () {
      this.tooltipVisible = false
    },
    handleToList (row) {
      this.$router.push({ path: '/lfd/warehouseManager/inventoryCurrent' })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .dv-scroll-board .rows .ceil {
  font-size: 13px !important;
}
#table1 {
  width: 100%;
  height: 100%;
  padding: 10px;
  display: flex;
  flex-direction: column;
  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      color: #c3cbde;
      font-size: 15px;
      margin-right: 10px;
    }
  }
  .no-data {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #fff;
  }
}
</style>
